import type { Extension, Mark, Node } from '@tiptap/react';

export type EditorPreset = 'comments' | 'guide_intro' | 'answers' | 'wiki';
export type TiptapExtension = Extension | Mark | Node;

export * from './MenuBar';
export * from './utils';
